import React from "react";
import { AuthContextType } from "../../types/account";

export const AuthContext = React.createContext<AuthContextType>(null!);
